import { Controller } from "@hotwired/stimulus"

// Controller dédié pour les onglets de profil avec liquid glass design
// Connects to data-controller="profile-tabs"
export default class extends Controller {
  static targets = ["panel"]
  static values = {
    default: String
  }

  connect() {
    // Activate default tab on load
    const defaultTab = this.defaultValue || "cv"
    this.activateTab(defaultTab)
  }

  switch(event) {
    event.preventDefault()
    const tabName = event.params.value
    this.activateTab(tabName)
  }

  activateTab(tabName) {
    // Get all tab buttons
    const tabButtons = this.element.querySelectorAll('[data-action*="profile-tabs#switch"]')

    // Update tab button styles
    tabButtons.forEach(button => {
      const buttonTabName = button.dataset.profileTabsValueParam
      if (buttonTabName === tabName) {
        button.classList.remove("liquid-glass-tab")
        button.classList.add("liquid-glass-tab-active")
      } else {
        button.classList.remove("liquid-glass-tab-active")
        button.classList.add("liquid-glass-tab")
      }
    })

    // Show/hide panels
    this.panelTargets.forEach(panel => {
      const panelName = panel.dataset.tabName
      if (panelName === tabName) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
